import { ROUTES, TITLES, PROD, DEV, STAGE } from 'consts';

export const START_SETTLEMENT_MENU = {
  key: ROUTES.START_SETTLEMENT.ROOT,
  label: TITLES[ROUTES.START_SETTLEMENT.ROOT],
  environment: [DEV, STAGE, PROD],
};
